<template>
    <div class="main-container">
        <div class="title-header" style="margin: 20px 0">
            <h1 class="title">Busqueda de practicantes</h1>
        </div>
        <div style="padding: 1rem 3rem 3rem 3rem">
            <v-row
                style="
                    display: flex;
                    justify-content: center;
                    align-content: center;
                ">
                <v-col
                    cols="12"
                    md="10"
                    class="d-flex justify-center align-center">
                    <v-text-field
                        flat
                        density="compact"
                        variant="outlined"
                        label="Buscar practicante"
                        hide-details
                        prepend-inner-icon="mdi-magnify"
                        v-model="searchPractitioner"
                        @input="debouncedSearchPractitioner"></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    md="2"
                    class="d-flex justify-center align-center">
                    <router-link to="/admin/crearPracticante">
                        <button class="boton-principal pr-2">
                            <v-icon
                                icon="mdi-account-plus"
                                color="white"
                                class="icon"></v-icon>
                            Crear Practicante
                        </button>
                    </router-link>
                </v-col>
            </v-row>
            <v-row>
                <EasyDataTable
                    table-class-name="customize-table"
                    buttons-pagination
                    show-index
                    alternating
                    :headers="headers"
                    :items="items"
                    @click-row="showRow"
                    class="headers"
                    :rows-per-page="rowsPerPage">
                    <template #item-operation="item">
                        <!-- el atributo 'to' tiene que extraer los numeros del id para poder acceder correctamente al paciente -->
                        <v-btn
                            class="ma-2 pa-2 boton-expediente"
                            @click="assignPractitionerId(item.id)"
                            :to="{
                                name: 'Practicante',
                                params: { id: item.id },
                            }"
                            variant="plain">
                            Ver recetas
                        </v-btn>
                    </template>
                </EasyDataTable>
            </v-row>
            <v-row class="mt-6 justify-end">
                <router-link to="/admin/sucursales">
                    <button class="boton-principal pr-2">
                        <v-icon
                            icon="mdi mdi-store"
                            color="white"
                            class="icon"></v-icon>
                        Gestionar Sucursales
                    </button>
                </router-link>
            </v-row>
        </div>
    </div>
</template>

<script>
import EasyDataTable from 'vue3-easy-data-table';
import { getAllPractitioners } from '@/api/practicante';
import { debounce } from '@/utils/debounce';

export default {
    components: {
        EasyDataTable,
    },
    methods: {
        showRow(row) {
            this.selectedPractitioner = row.id;
        },

        editItem(item) {
            this.showDialog1 = true;
            this.selectedPractitioner = item;
        },
        closeDialog() {
            this.showDialog = !this.showDialog;
        },
        assignPractitionerId(item) {
            localStorage.setItem('PractitionerId', item);
        },
        viewItem(item) {
            this.showDialog = true;
            this.selectedPractitioner = item;
        },
        debouncedSearchPractitioner: debounce(function () {
            const endpoint = !isNaN(Number(this.searchPractitioner.trim()))
                ? `/${this.searchPractitioner}`
                : `/search/${this.searchPractitioner}`;
            getAllPractitioners(endpoint)
                .then((items) => {
                    const newItems = items.map((item) => {
                        return {
                            id:
                                typeof item.identifier[0] !== 'string'
                                    ? item.identifier[0].value
                                    : item.identifier,
                            nombre: item.name,
                            apellido: item.lastname,
                            cedula: item.qualification[0].identifier,
                        };
                    });

                    this.items = newItems;
                })
                .catch((error) => {
                    console.error('Error message:', error.message);
                    if (error.response && error.response.data) {
                        console.error('Response data:', error.response.data);
                    }
                    this.items = [];
                });
        }, 300),
    },

    mounted() {
        this.debouncedSearchPractitioner();
    },

    data() {
        return {
            showDialog: false,
            showPractitionerUpdate: false,
            selectedPractitioner: null,
            searchPractitioner: '',
            headers: [
                { text: 'ID', value: 'id', sortable: true },
                { text: 'Nombre(s)', value: 'nombre', sortable: true },
                { text: 'Apellido(s)', value: 'apellido', sortable: true },
                { text: 'Cedula Profesional', value: 'cedula' },
                { text: 'Acciones', value: 'operation' },
            ],
            items: [],
            rowsPerPage: 10,
        };
    },
};
</script>

<style>
/* =- */
.headers div table thead tr th span {
    color: var(--color-secundario);
    /* agregar el font, SUBTITULO */
    font-size: 15px;
}
.boton-expediente {
    color: #40b4e5;
    text-decoration: underline;
}
.altura-boton {
    height: 40px;
    position: relative;
    top: 29px;
}

.cabezera {
    color: white;
    text-align: center;
}

.font {
    color: white;
}

.customize-table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid black;
    border-radius: 10px;
}

.icon {
    align-self: Center;
    color: black;
    margin-right: 2px;
    margin-left: 1px;
}

.table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid black;
    border-radius: 10px;
}
</style>
